module.exports = __webpack_public_path__ + "static/media/ic_question.8cdae8ab.svg";